import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>
          Прикольная футболка для вашего питомца выполнена из хлопковой ткани с добавлением полиэстера. 
          Не стесняет движения собаки и радует хозяина прикольными принтами.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`dog_tee`],
      sizeInfo: `dog_tee`
    }
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
